import React from "react";
import { Table } from "hooks/useQuery/api-query";
import useRowSelect, { SelectRowContext } from "hooks/useRowSelectNew";
import TableRow from "./therapy-data-table-row";
import PropTypes from "prop-types";

import { useFetch } from "hooks";
import { path } from "ramda";
import { put } from "utils/api";
import { getApiErrorMessage } from "utils/misc";
import * as msg from "actions/message";
import { useDispatch } from 'react-redux';

export default function TherapyDataList({
    queryDispatcher,
    query,
    rows,
    data,
    isFetching,
    setComponentToRender,
    setTherapyIdToEdit,
    userRole,
    patientId
}) {

    const {
        toggleAllRows,
        isRowSelected,
        toggleRow,
        clearSelectedRows,
        selectedRows
    } = useRowSelect(rows, "Id", query, row => ({
        Id: `${row.Id}`
    }));


    const { fetchData: deletePatientTherapyData, isFetching: isDeleting } = useFetch({
        apiFn: (TherapyDataId) =>
            put(`patients/${patientId}/therapy-data/${TherapyDataId}/deactivate`),
        defaultValue: {},
        transformError: path(["response", "body", "status"]),
        onError: error => {
            dispatch(
                msg.errorMessage(`Failed to delete entry: ${getApiErrorMessage(error)}`)
            );
        }
    });

    const dispatch = useDispatch();

    const onEdit = (row) => {
        setTherapyIdToEdit(row?.Id)
        setComponentToRender("therapyDataEditEntry")
    }
    
    return (
        <div className="patients-table-tab">
            <SelectRowContext.Provider
                value={{
                    toggleAllRows,
                    toggleRow,
                    selectedRows,
                    isRowSelected,
                    clearSelectedRows
                }}
            >
                <Table
                    query={query}
                    data={data}
                    queryDispatcher={queryDispatcher}
                    isFetching={isFetching}
                    containerClass="query-table patients-table dynamic-columns"
                    customNotFoundMessage="No therapy data for this patient"
                    columns={[
                        {
                            header: "Serial Number",
                            field: "serialNumber",
                            hasSort: false
                        },
                        {
                            header: "Source",
                            field: "source",
                            hasSort: false
                        },
                        {
                            header: "Imported",
                            field: "imported",
                            hasSort: false
                        },
                        {
                            header: "Usage Date",
                            field: "usageDate",
                            hasSort: false
                        },
                        {
                            header: "Usage",
                            field: "usage",
                            hasSort: false
                        },
                        {
                            header: "Pressure",
                            field: "pressure",
                            hasSort: false
                        },
                        {
                            header: "P95",
                            field: "p95",
                            hasSort: false
                        },
                        {
                            header: "AHI",
                            field: "ahi",
                            hasSort: false
                        },
                        {
                            header: "Leak",
                            field: "leak",
                            hasSort: false
                        },
                        {
                            header: "Created By",
                            field: "createdBy",
                            hasSort: false
                        },
                        {
                            header: "",
                            field: "CanEdit",
                            hasSort: false
                        }
                    ]}
                    rows={rows}
                    TableRow={row =>
                        <TableRow
                            {...row}
                            onEdit={() => onEdit(row)}
                            onDelete={deletePatientTherapyData}
                            isDeleting={isDeleting}
                            userRole={userRole}
                        />
                    }
                    rowKey="Id"
                    renderFooter={false}
                    hasSort={false}
                />
            </SelectRowContext.Provider>
        </div>
    );
}

TherapyDataList.propTypes = {
    timeZone: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    resetTimeZoneValue: PropTypes.func,
    queryDispatcher: PropTypes.func,
    query: PropTypes.shape({
        filters: PropTypes.shape({ PatientId: PropTypes.string })
    }),
    rows: PropTypes.array,
    data: PropTypes.object,
    isFetching: PropTypes.bool,
    setComponentToRender: PropTypes.func,
    setTherapyIdToEdit: PropTypes.func,
    userRole: PropTypes.string,
    patientId: PropTypes.string
};
